import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const ScalesIcon: FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_7665_4885)"><path d="M7 13C7 14.66 5.66 16 4 16C2.34 16 1 14.66 1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M23 13C23 14.66 21.66 16 20 16C18.34 16 17 14.66 17 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 5V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M23 13L20 7L17 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 13L4 7L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M4 7H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M8 20H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<defs><clipPath id="clip0_7665_4885"><rect width="24" height="24" fill="currentColor" /></clipPath></defs></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ScalesIcon;